module.exports = __webpack_public_path__ + "static/media/accountSummary_blue.da66a12d.svg";